module.exports = __webpack_public_path__ + "1.5.0-unryo/img/consul.d526fd3d.svg";